import {
  BASE_URL_SCHOOLSIMS,
  BEST_PRACTISES_URL,
  BLOGS_URL,
  CLIENT_TESTIMONIALS_URL,
  EVENTS_URL,
  RESEARCH_URL,
  WEBINARS_URL,
} from "../../constants";
import {
  ACCOUNT_TYPE,
  ROLE,
  V2_DASHBOARD_PATH,
} from "../../utils/constants";

/**
 * Client Admin sidebar. Dashboard stays in the v2 shell. Legacy routes
 * open in the same tab, except View Simulations, which opens /sims in a
 * new tab (same as the previous sidebar).
 */
export const CLIENT_ADMIN_NAV = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: V2_DASHBOARD_PATH,
    icon: "fas fa-home",
    group: "main",
  },
  {
    id: "cohorts",
    label: "Cohort Management",
    href: "/cohorts",
    icon: "fas fa-users-cog",
    requiresAccType: true,
    group: "main",
  },
  {
    id: "participants",
    label: "Participant Management",
    href: "/cohorts-participants",
    icon: "fas fa-user-friends",
    requiresAccType: true,
    group: "main",
  },
  {
    id: "cohorts-insight",
    label: "Cohorts Insight Dashboard",
    href: "/cohorts-insight-dashboard",
    icon: "fas fa-chalkboard-teacher",
    requiresAccType: true,
    group: "main",
  },
  {
    id: "accreditation",
    label: "Accreditation Dashboard",
    href: "/accreditation-dashboard",
    icon: "fas fa-clipboard",
    requiresHigherEd: true,
    group: "main",
  },
  {
    id: "share-simulations",
    label: "Share Simulations",
    href: "/simulations",
    icon: "fas fa-digital-tachograph",
    group: "main",
  },
  {
    id: "link-management",
    label: "Link Management",
    href: "/simulations/links",
    icon: "fas fa-unlink",
    group: "main",
  },
  {
    id: "view-simulations",
    label: "View Simulations",
    href: "/sims",
    icon: "fas fa-eye",
    openInNewTab: true,
    group: "main",
  },
  {
    id: "reports",
    label: "Reports Management",
    href: "/reports",
    icon: "fas fa-clipboard-list",
    group: "resources",
  },
  {
    id: "webinars",
    label: "Webinars",
    href: BASE_URL_SCHOOLSIMS + WEBINARS_URL,
    icon: "fa fa-podcast",
    external: true,
    group: "resources",
  },
  {
    id: "blog",
    label: "Blog",
    href: BASE_URL_SCHOOLSIMS + BLOGS_URL,
    icon: "fab fa-blogger-b",
    external: true,
    group: "resources",
  },
  {
    id: "best-practices",
    label: "Best Practices",
    href: BASE_URL_SCHOOLSIMS + BEST_PRACTISES_URL,
    icon: "fa fa-award",
    external: true,
    group: "resources",
  },
  {
    id: "events",
    label: "Upcoming Events",
    href: BASE_URL_SCHOOLSIMS + EVENTS_URL,
    icon: "far fa-calendar-alt",
    external: true,
    group: "resources",
  },
  {
    id: "users",
    label: "User Management",
    href: "/users",
    icon: "fas fa-users",
    group: "admin",
  },
];

export const RESEARCH_LINKS = {
  research: BASE_URL_SCHOOLSIMS + RESEARCH_URL,
  webinars: BASE_URL_SCHOOLSIMS + WEBINARS_URL,
  whitePapers: BASE_URL_SCHOOLSIMS + CLIENT_TESTIMONIALS_URL,
};

export function isHigherEdAccType(accType) {
  if (accType == null || accType === "") return false;
  const normalized = String(accType)
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ");
  return (
    accType === ACCOUNT_TYPE.HIGHER_ED ||
    normalized === "higher ed" ||
    normalized === "highered"
  );
}

export function filterClientAdminNav(items, options = {}) {
  const { accType, roleName } = options;
  const isHigherEd = isHigherEdAccType(accType);
  const isSuperAdmin = roleName === ROLE.Role_Super_Admin;

  return items.filter((item) => {
    if (item.requiresHigherEd && !isHigherEd && !isSuperAdmin) return false;
    return true;
  });
}
